<ng-template #loadingOrError>
	<div class="loader-infos-label" *ngIf="isLoading" translate>loader.text</div>
	<copo-loading-spinner *ngIf="isLoading" class="loader-infos-label"></copo-loading-spinner>
</ng-template>

<div class="copo-search-filter-title">
	<div translate>offers.product.list</div>
</div>
<div *ngIf="!isLoading && isError" class="copo-notification-block-eorder">
	<mat-icon svgIcon="alert" [attr.title]="'quapp.alert' | translate" class="copo-notification-icon-eorder copo-hint-warning wrap-error"></mat-icon>
	<div class="copo-offer-flex-container-col">
		<div translate>quapp.error</div>
		<div class="card-header-label-eorder" translate>global.error</div> 
	</div>
</div>
<ng-container *ngIf="!isLoading && !isError else loadingOrError">
	<div class="copo-container-eorder">
		<div class="card-block-eorder" *ngIf="!isCustomerNotSelected">
			<div class="card-infos-block">
				<div class="card-infos sub-description"> 
					<div *ngIf=" productFamilies && productFamilies.length > 0 else noProductFamily" class="copo-offer-buttons-group">
						<button
							*ngFor="let productFamily of productFamilies"
							type="button" mat-flat-button [color]="getSelectedProductFamilyCode() === productFamily.code || isDefault ? 'primary' : undefined"
							[class.copo-button-selection-selected]="getSelectedProductFamilyCode() === productFamily.code || isDefault"
							class="copo-button-selection"
							(click)="familyProductChanged(productFamily.code)"
						>
							<div class="copo-offer-toggle-title">{{productFamily.subCategoryDescription}}</div>
							<div class="copo-offer-toggle-subtitle">{{productFamily.formDescription | titlecase}}</div>
						</button>
					</div>

					<ng-template #noProductFamily>
						<span
							#textSelectProductSpec
							[class.copo-offer-alert]="wasChecked && getRequestedProductCount() === 0"
							class="eorder-nodata-label"
							translate
						>eorder.no.product.family</span> 
					</ng-template>
				</div>
			</div>
		</div>
	</div>
		<ng-template #loadingProducts>
			<div class="loader-infos-label" *ngIf="isProductLoading" translate>loader.text</div>
			<copo-loading-spinner *ngIf="isProductLoading" class="loader-infos-label"></copo-loading-spinner>
		</ng-template>
		<ng-container *ngIf="!isProductLoading && selectedProductFamilies.length > 0 && products else loadingProducts">
			<copo-offer-product-list *ngFor="let selectedProductFamily of selectedProductFamilies"
			[products]="products" [soldTo]="soldToValue" [subCategory]="getSelectedProductFamilySubcategoryCode()"
			[form]="getSelectedProductFamilyForm()">
			</copo-offer-product-list>
		</ng-container>
</ng-container>
